import { QueryConfig } from "store/utils/query-config";

export const testimonialsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["createdAt"],
  },
};
